import { useState, useEffect } from 'react';

export const useTitanConfig = (activeTab, selectedGame) => {
    const [titanConfigData, setTitanConfigData] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (activeTab !== 1) return;

        if (!selectedGame?.lobby) {
            setTitanConfigData(null);
            setErrorMessage('Please check the lobby name field.');
            return;
        }

        const fetchTitanConfig = async () => {
            try {
                const response = await fetch(
                    `https://mobile67.gamedistribute.com/htmlgames/config?brand=${selectedGame.lobby.name}`
                );
                if (!response.ok) throw new Error('Failed to fetch data');
                const data = await response.json();
                setTitanConfigData(data);
                setErrorMessage('');
            } catch (error) {
                setTitanConfigData(null);
                setErrorMessage('Error fetching Titan Config. Please check the lobby name field.');
                console.error('Fetch error:', error);
            }
        };

        fetchTitanConfig();
    }, [activeTab, selectedGame?.lobby]);

    return { titanConfigData, errorMessage };
};
